import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import {FC} from 'react';
import {c} from 'ttag';

const NavigationTabsPartnerOverview: FC<NavigationTabsPropsHelper> = ({
    className,
    selection,
}) => (
    <BaseNavigationTabs className={className} selection={selection}>
        <BaseNavigationTabsButton
            href={window.Urls.partner_item_view()}
            label={c('component').t`Settings`}
            name="settings"
        />
        <BaseNavigationTabsButton
            href={window.Urls.partner_import_view()}
            label={c('component').t`Data Import`}
            name="dataImport"
        />
        <BaseNavigationTabsButton
            href={window.Urls.document_export_view()}
            label={c('component').t`Data Export`}
            name="dataExport"
        />
        <BaseNavigationTabsButton
            href={window.Urls.connected_apps_view()}
            label={c('component').t`Integrations`}
            name="integrations"
        />
        <BaseNavigationTabsButton
            href={window.Urls.beta_list_view()}
            label={c('component').t`Early Access`}
            name="earlyAccess"
        />
        <BaseNavigationTabsButton
            href={window.Urls.billing_index()}
            label={c('component').t`Billing & Plan`}
            name="billingAndPlan"
        />
    </BaseNavigationTabs>
);

export default NavigationTabsPartnerOverview;
